import { Text } from "@chakra-ui/react";
import { themeLabel } from "src/models/companion";

/** Small glass pill naming the companion's world, for picture corners. */
export function ThemeBadge({ theme }: { theme: string }) {
  return (
    <Text
      as="span"
      fontSize="10px"
      fontWeight="semibold"
      textTransform="uppercase"
      letterSpacing="0.06em"
      px={2}
      py="3px"
      borderRadius="full"
      bg="rgba(0,0,0,0.45)"
      backdropFilter="blur(8px)"
      color="white"
    >
      {themeLabel(theme)}
    </Text>
  );
}
